import React from "react";
import { useGetDataReadinessUrl } from "hooks";
import { CommonQuicksightDashboard } from "../components";

export const DataReadinessTab = () => {
  const { data: dataReadinessResponse, isLoading: isLoadingDataReadiness } = useGetDataReadinessUrl();

  return (
    <CommonQuicksightDashboard
      title="Data Readiness"
      embedUrl={dataReadinessResponse?.embedUrl ?? ""}
      isLoading={isLoadingDataReadiness}
    />
  );
};
